import Session from "../auth/Session"

const AuthFunctions = {
    callbacks: [],
    signInAsync: async function (username, password) {
        const response = await fetch(`api/Account/token`, {
            method: "POST",
            body: JSON.stringify({ "Username": username, "Password": password }),
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    signOut: function () {
        Session.removeUserSession();
        return Session.getToken() === null;
    },
    getAuthenticatedAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Account/IsAuthenticated`, {
            method: "GET",
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            return false;
        }
    },
    getIsAdminAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/IsAdminUserAsync`, {
            method: "GET",
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    }
}

export default AuthFunctions;